var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAndroidWifiBar = function SvgAndroidWifiBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m2.956 10.6-1.77-1.77a15.6 15.6 0 0 1 4.986-3.21A15.5 15.5 0 0 1 12 4.5q3.036 0 5.828 1.12a15.6 15.6 0 0 1 4.986 3.21l-1.77 1.77a13 13 0 0 0-4.174-2.671A13.1 13.1 0 0 0 12 7q-2.532 0-4.87.929-2.338.93-4.174 2.671m4.119 4.1-1.754-1.754a9.8 9.8 0 0 1 3.087-1.992A9.5 9.5 0 0 1 12 10.26q1.884 0 3.611.699a9.7 9.7 0 0 1 3.097 2.007l-1.773 1.744A7.13 7.13 0 0 0 12 12.76q-1.396 0-2.655.5a7.2 7.2 0 0 0-2.27 1.44M12 19.5q-.729 0-1.24-.51-.51-.511-.51-1.24t.51-1.24T12 16t1.24.51q.51.511.51 1.24t-.51 1.24-1.24.51"
  })));
};
export default SvgAndroidWifiBar;